import { Spin } from 'antd';
import React from 'react';

export default function PageLoader({ loading , fullscreen = true , size = 'large' }) {
	return <Spin fullscreen={fullscreen} size={size} />;
}
